export const iconFontAwesomeMovingSuitcase = (
	<i className="fa-solid fa-suitcase"></i>
);
